import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 日历海报素材库列表
export const getPosterDayList = params => {
    return get("/admin/posterMaterial", params);
};
// 新增日历海报素材
export const addPosterDay = params => {
    return post("/admin/posterMaterial", params);
};
// 修改素材信息
export const editPosterDay = params => {
    return put("/admin/posterMaterial/edit", params);
};
// 获取素材类型列表
// export const getPosterDayTypeList = params => {
//     return get("/admin/posterMaterial/materialTypes");
// };
// 删除素材
export const deletePosterDay = params => {
    return del(`/admin/posterMaterial/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/poster_day.js